
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 14 14"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M10.5 5.287a1.78 1.78 0 00-.525-1.262 1.831 1.831 0 00-2.528 0L.525 10.948a1.787 1.787 0 002.526 2.527L9.975 6.55a1.777 1.777 0 00.525-1.264zm-8.274 7.364a.634.634 0 01-.875 0 .62.62 0 010-.875l4.532-4.532.878.878-4.535 4.53zm6.925-6.925L7.583 7.294l-.875-.877 1.569-1.568a.62.62 0 11.875.875v.002zm-6.314-4.06l.904-.259.258-.904a.695.695 0 011.336 0l.257.904.905.258a.695.695 0 010 1.336l-.905.258-.257.904a.695.695 0 01-1.336 0L3.74 3.26l-.904-.258a.695.695 0 010-1.336zM13.497 10l-.905.258-.258.904a.694.694 0 01-1.335 0l-.258-.904L9.837 10a.695.695 0 010-1.336l.904-.258.258-.904a.695.695 0 011.335 0l.258.904.904.258a.695.695 0 010 1.336zm-3.14-8.543l.791-.226.227-.792a.607.607 0 011.167 0l.225.791.791.226a.608.608 0 010 1.167l-.79.225-.226.793a.607.607 0 01-1.167 0l-.226-.79-.792-.227a.608.608 0 010-1.167z"}})])
          )
        }
      }
    